/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SentEdi204File
 */
export interface SentEdi204File {
  /**
   *
   * @type {string}
   * @memberof SentEdi204File
   */
  filename: string;
  /**
   *
   * @type {string}
   * @memberof SentEdi204File
   */
  content: string;
}

/**
 * Check if a given object implements the SentEdi204File interface.
 */
export function instanceOfSentEdi204File(
  value: object,
): value is SentEdi204File {
  if (!("filename" in value) || value["filename"] === undefined) return false;
  if (!("content" in value) || value["content"] === undefined) return false;
  return true;
}

export function SentEdi204FileFromJSON(json: any): SentEdi204File {
  return SentEdi204FileFromJSONTyped(json, false);
}

export function SentEdi204FileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SentEdi204File {
  if (json == null) {
    return json;
  }
  return {
    filename: json["filename"],
    content: json["content"],
  };
}

export function SentEdi204FileToJSON(json: any): SentEdi204File {
  return SentEdi204FileToJSONTyped(json, false);
}

export function SentEdi204FileToJSONTyped(
  value?: SentEdi204File | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    filename: value["filename"],
    content: value["content"],
  };
}
